var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgExpandCircleUpOutlined(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 20C7.45614 20 4 16.5439 4 12C4 7.45614 7.45614 4 12 4C16.5439 4 20 7.45614 20 12C20 16.5439 16.5439 20 12 20ZM12 22C17.5263 22 22 17.5263 22 12C22 6.47368 17.5263 2 12 2C6.47368 2 2 6.47368 2 12C2 17.5263 6.47368 22 12 22ZM9.70175 13.7018L12.7018 10.7018C12.8947 10.5263 13 10.2807 13 10C13 9.45614 12.5439 9 12 9C11.7193 9 11.4737 9.10526 11.2982 9.29825L8.29825 12.2982C8.10526 12.4737 8 12.7193 8 13C8 13.5439 8.45614 14 9 14C9.2807 14 9.52632 13.8947 9.70175 13.7018ZM11.2982 10.7018L14.2982 13.7018C14.4737 13.8947 14.7193 14 15 14C15.5439 14 16 13.5439 16 13C16 12.7193 15.8947 12.4737 15.7018 12.2982L12.7018 9.29825C12.5263 9.10526 12.2807 9 12 9C11.4561 9 11 9.45614 11 10C11 10.2807 11.1053 10.5263 11.2982 10.7018Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpandCircleUpOutlined);
export default __webpack_public_path__ + "static/media/expand_circle_up_outlined.e778dd36.svg";
export { ForwardRef as ReactComponent };